import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

@Injectable()
export class SubmittedErrorStateMatcher implements ErrorStateMatcher {
  submitted = false;

  isErrorState(control: AbstractControl | null): boolean {
    return !!control && control.invalid && this.submitted;
  }
}
